import { Icon, Tooltip } from '@mui/material';
import { lightBlue } from '@mui/material/colors';
import React from 'react';
import theme from 'theme';

function AppleHealthTooltip({
  text,
  iconType,
  icon,
}: {
  text: React.ReactElement | string;
  iconType?: string;
  icon?: React.ReactElement;
}) {
  return (
    <Tooltip
      title={text}
      arrow
      placement='top'
      componentsProps={{
        tooltip: {
          sx: {
            boxShadow: '0px 5px 8px 0px rgba(0, 0, 0, 0.25)',
            maxWidth: 400,
            bgcolor: lightBlue[50],
            color: 'black',
            '& .MuiTooltip-arrow': {
              color: lightBlue[50],
            },
          },
        },
      }}
    >
      {icon || (
      <Icon sx={{ color: 'primary.main', ml: 0.5, cursor: 'pointer', fontSize: theme.typography.pxToRem(16) }}>
        {iconType}
      </Icon>
      )}
    </Tooltip>
  );
}

export default AppleHealthTooltip;
